/* eslint-disable @next/next/no-html-link-for-pages */
import Head from 'next/head';
import Link from 'next/link';
import { GetPathName } from '@/lib/helpers';
import LoginForm from '@/components/templates/LoginForm';
import ToolsAndServicesTemplate from '@/components/templates/ToolsAndServicesTemplate';
import WebdienstTemplate from '@/components/templates/WebdienstTemplate';

const Page = () => {
  return (
    <>
      <Head>
        <title>Corporate-Design - Templates</title>
      </Head>

      <h1>Templates</h1>
      <p className="lead">
        Beschleunigen Sie die Umsetzung Ihres Projekts mit Vorlagen,
        zusammengesetzt aus bestehenden Komponenten des Styleguides. Häufig
        verwendete Seiten werden hier zur Verfügung gestellt.
      </p>
      <h2>Webdienste</h2>
      <p>
        <strong>Komponenten:</strong>
      </p>
      <ul className="list-arrow">
        <li>
          <a
            href={`${process.env.NEXT_PUBLIC_BASE_URL}/basic-elements/webdienst-header`}
            title="PAAS - Webdienst-Header"
          >
            Webdienst-Header
          </a>
        </li>
        <li>Inhaltsbereich mit Titel und Lead-Text</li>
        <li>
          <Link href={`/basic-elements/webdienst-footer`} legacyBehavior>
            <a title="Webdienst-Footer">Webdienst-Footer</a>
          </Link>
        </li>
      </ul>
      <WebdienstTemplate />
      <hr className="my-5" />
      <h2>Tools & Service</h2>
      <p>
        <strong>Komponenten:</strong>
      </p>
      <ul className="list-arrow">
        <li>
          <Link href={`/basic-elements/tools-header`} legacyBehavior>
            <a title="Tools-Header">Tools-Header</a>
          </Link>
        </li>
        <li>Inhaltsbereich mit Titel und Lead-Text</li>
        <li>
          <Link href={`/basic-elements/tools-footer`} legacyBehavior>
            <a title="Tools-Footer">Tools-Footer</a>
          </Link>
        </li>
      </ul>
      <ToolsAndServicesTemplate />
      <hr className="my-5" />
      <h2>Login Form</h2>
      <LoginForm />
      <hr className="my-5" />
    </>
  );
};

export default Page;
